module.exports = __webpack_public_path__ + "img/Barrett.0bd9994.png";